import {
  Box, IconButton, Typography,
} from '@mui/material';
import styled from 'styled-components';

import {
  BaseColorKeys, NotifierColorKeys, SubjectColorKeys,
} from '../../theme';

interface ColorProps {
  color: BaseColorKeys | SubjectColorKeys | NotifierColorKeys;
}

interface ContainerProps {
  $scrollY?: boolean;
}

const Container = styled(Box)<ContainerProps>`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: min(400px, 95%);
    max-width: 95%;
    background-color: ${({ theme }) => theme.palette.backdrop.light};
    box-shadow: 24;
    padding: ${({ theme }) => theme.spacing(3)};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    outline: none;
  }
`;

const CloseIconButton = styled(IconButton)`
  && {
    position: absolute;
    right: ${({ theme }) => theme.spacing(2)};
    top: ${({ theme }) => theme.spacing(2)};
  }
`;

const TitleContainer = styled.div<ColorProps>`
  color: ${({ theme, color }) => theme.palette[color].dark};
`;

const Title = styled(Typography)`
`;

const Description = styled(Typography).attrs({
  component: 'div',
})`
  && {
    margin-top: ${({ theme }) => theme.spacing(2)};
  }
`;

const ButtonBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

interface ChildBoxProps {
  $scrollY?: boolean;
}

const ChildBox = styled.div<ChildBoxProps>`
  margin-top: ${({ theme }) => theme.spacing(2)};
  max-height: ${({ $scrollY }) => ($scrollY ? '80vh' : 'none')};
  overflow-y: ${({ $scrollY }) => ($scrollY ? 'scroll' : 'visible')};
`;

export { Container,
  CloseIconButton,
  Title,
  TitleContainer,
  Description,
  ButtonBar,
  ChildBox };
